import { render, staticRenderFns } from "./ModifyUserSavedMoney.vue?vue&type=template&id=da17c510"
import script from "./ModifyUserSavedMoney.vue?vue&type=script&lang=js"
export * from "./ModifyUserSavedMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports